import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { useDispatch, useSelector } from 'react-redux';

import BrokersConnection from 'components/BrokersConnection';

import { AccessDeviceActions } from 'state/modules/accessDevice';
import { OrganizationsActions } from 'state/modules/organizations';
import i18n from 'i18n-js';

import useStyles from './Connections.styled';

const AccessDeviceConnections = ({ accessDevice, showLabel = true }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { fetchingAvailablesBrokers, availablesBrokers, loading } = useSelector(
    (state) => state.organizations
  );

  const addBrokerToAccessDevice = (value) => {
    dispatch(AccessDeviceActions.fetchAddBroker(accessDevice?.id, value));
  };

  const removeBroker = (value) => {
    dispatch(AccessDeviceActions.fetchRemoveBroker(accessDevice?.id, value?.broker_slug));
  };

  useEffect(() => {
    dispatch(
      OrganizationsActions.fetchAvailablesBrokers({ class_slug: 'AD', include_non_primary: true })
    );
  }, []); // eslint-disable-line

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography gutterBottom component="div" align="left">
              <Box fontWeight="500" fontSize={14} pr={4} mt={2} mb={4}>
                {showLabel ? i18n.t('vehicle.select_broker') : ''}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <BrokersConnection
              availables={{
                list: [...availablesBrokers],
                loading: fetchingAvailablesBrokers,
              }}
              loading={loading}
              onAddBroker={addBrokerToAccessDevice}
              onRemoveBroker={removeBroker}
              assigned={accessDevice?.brokers || {}}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

AccessDeviceConnections.propTypes = {
  accessDevice: PropTypes.object,
  showLabel: PropTypes.bool,
};

export default AccessDeviceConnections;
